// extracted by mini-css-extract-plugin
export default {"container":"Gl","overlay":"Hl","videoOverlay":"Il","withHeader":"Jl","header":"Kl","close":"Ll","content":"Ml"};